(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('.yx-ymal').forEach((sec) => {
    const track = sec.querySelector('[data-yx-related-track]');
    if (!track) return;

    const prev = sec.querySelector('[data-yx-related-prev]');
    const next = sec.querySelector('[data-yx-related-next]');

    // Mirror the mock: the arrow pointing at an unreachable edge is faint (disabled).
    const syncArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    };

    sec.querySelectorAll('[data-yx-related-prev],[data-yx-related-next]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = track.querySelector('li');
        const step = (card ? card.getBoundingClientRect().width : 299) + 25;
        track.scrollBy({ left: btn.hasAttribute('data-yx-related-prev') ? -step : step, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows, { passive: true });
    syncArrows();

  });
})();

(() => {
  const ymal = document.querySelector('.yx-cart__ymal .yx-ymal');
  if (!ymal) return;
  const fit = () => {
    const width = window.innerWidth;
    ymal.style.zoom = width >= 1920 ? '1' : '';
  };
  fit();
  window.addEventListener('resize', fit, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yurinox-estimated-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
  const names = Object.freeze({
    yurinox_standard_v1: 'Standard',
    yurinox_optima_v1: 'Optima',
    yurinox_express_v1: 'Express',
  });
  const states = new Set('AL AZ AR CA CO CT DE DC FL GA ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' '));
  const addressLifetime = 30 * 60 * 1000;
  const rateLifetime = 60000;
  const addressKey = `yurinox-shipping-address-v1:${location.host}`;
  const pause = (ms, signal) => new Promise((resolve, reject) => {
    const abort = () => {
      clearTimeout(timer);
      reject(new DOMException('Aborted', 'AbortError'));
    };
    const timer = setTimeout(() => {
      signal.removeEventListener('abort', abort);
      resolve();
    }, ms);
    if (signal.aborted) abort();
    else signal.addEventListener('abort', abort, { once: true });
  });
  const calendarDate = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const date = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(date.valueOf()) && date.toISOString().slice(0, 10) === value ? date : null;
  };
  const normalizedAddress = (value) => {
    const address = { country: 'United States' };
    if (value?.country && !['United States', 'US'].includes(value.country)) return null;
    for (const field of ['address1', 'city', 'province', 'zip']) {
      address[field] = typeof value?.[field] === 'string' ? value[field].trim() : '';
    }
    return address.address1 && address.city && states.has(address.province) && /^\d{5}(-\d{4})?$/.test(address.zip) ? address : null;
  };
  const cartIdentity = (cart) => JSON.stringify({
    token: cart.token,
    currency: cart.currency,
    total_price: cart.total_price,
    items: cart.items?.map(({ key, quantity, final_line_price, grams, requires_shipping, selling_plan_allocation }) => ({
      key, quantity, final_line_price, grams, requires_shipping, selling_plan_allocation,
    })),
    discount_codes: cart.discount_codes,
    cart_level_discount_applications: cart.cart_level_discount_applications,
  });
  const normalizeRates = (payload, currency, carrierId) => {
    if (!Array.isArray(payload?.shipping_rates) || !payload.shipping_rates.length || !/^\d+$/.test(String(carrierId || ''))) throw new Error('No verified rates');
    if (!/^[A-Z]{3}$/.test(currency || '')) throw new Error('Missing currency');
    const seen = new Set();
    return payload.shipping_rates.map((rate) => {
      if (!Object.hasOwn(names, rate.code) || seen.has(rate.code) || String(rate.carrier_service_id) !== String(carrierId)) throw new Error('Unverified rate');
      seen.add(rate.code);
      const name = rate.presentment_name || rate.name;
      if (name !== names[rate.code] || (rate.currency && rate.currency !== currency)) throw new Error('Rate mismatch');
      if (typeof rate.price !== 'string' || !/^\d+(?:\.\d{1,2})?$/.test(rate.price)) throw new Error('Invalid price');
      const price = Number(rate.price);
      if (!Number.isFinite(price) || (price === 0 && rate.code !== 'yurinox_standard_v1')) throw new Error('Invalid free rate');
      let dates = [];
      if (rate.delivery_range?.length) {
        if (!Array.isArray(rate.delivery_range) || rate.delivery_range.length !== 2) throw new Error('Invalid date range');
        dates = rate.delivery_range.map(calendarDate);
        if (dates.some((date) => !date) || dates[0] > dates[1]) throw new Error('Invalid date range');
      } else if (rate.delivery_date) {
        dates = [calendarDate(rate.delivery_date)];
        if (!dates[0]) throw new Error('Invalid date');
      }
      return { code: rate.code, name, price, currency, free: price === 0, dates };
    }).sort((a, b) => Object.keys(names).indexOf(a.code) - Object.keys(names).indexOf(b.code));
  };
  if (customElements.get('yurinox-estimated-delivery')) return;

  class YurinoxEstimatedDelivery extends HTMLElement {
    address = null;
    generation = 0;
    active = null;
    expiry = null;
    scheduled = null;
    listeners = null;
    cartObserver = null;

    connectedCallback() {
      if (this.dataset.enabled !== 'true' || !/^\d+$/.test(this.dataset.carrierServiceId || '')) return;
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      document.addEventListener('cart:update', this.scheduleRefresh, options);
      document.addEventListener('discount:update', this.scheduleRefresh, options);
      document.addEventListener('quantity-selector:update', this.invalidateForChange, options);
      document.addEventListener('visibilitychange', this.onVisibilityChange, options);
      window.addEventListener('pageshow', this.scheduleRefresh, options);
      this.querySelector('[data-shipping-calculate]')?.addEventListener('click', this.calculate, options);
      this.querySelector('[data-shipping-address]')?.addEventListener('input', this.onAddressEdit, options);
      this.querySelector('[data-shipping-address]')?.addEventListener('keydown', this.onAddressKeyDown, options);
      const cartRoot = this.closest('[data-yx-cart]');
      if (cartRoot) {
        this.cartObserver?.disconnect();
        this.cartObserver = new MutationObserver(() => {
          if (cartRoot.getAttribute('aria-busy') === 'true') this.invalidateForChange();
          else this.scheduleRefresh();
        });
        this.cartObserver.observe(cartRoot, { attributes: true, attributeFilter: ['aria-busy'] });
      }
      let address = null;
      try {
        const saved = JSON.parse(sessionStorage.getItem(addressKey) || 'null');
        if (saved?.expiresAt > Date.now()) address = normalizedAddress(saved.address);
        else sessionStorage.removeItem(addressKey);
      } catch {}
      this.address = address || normalizedAddress(this.readAddress());
      if (this.address) {
        for (const field of this.querySelectorAll('[data-shipping-field]')) field.value = this.address[field.dataset.shippingField] || '';
        this.scheduleRefresh();
      } else this.setStatus(this.dataset.addressPrompt);
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.cartObserver?.disconnect();
      this.cancel();
    }

    cancel() {
      this.generation += 1;
      this.active?.abort();
      this.active = null;
      clearTimeout(this.expiry);
      clearTimeout(this.scheduled);
    }

    setStatus(text) {
      const support = this.querySelector('[data-shipping-support]');
      if (support) support.hidden = true;
      for (const row of this.querySelectorAll('[data-service-code]')) {
        row.hidden = false;
        const price = row.querySelector('[data-shipping-price]');
        price.textContent = '';
        price.hidden = true;
        price.classList.remove('yurinox-estimated-delivery__price--free');
        row.querySelector('[data-shipping-date]').hidden = true;
        row.querySelector('[data-shipping-date-value]').replaceChildren();
      }
      const status = this.querySelector('[data-shipping-status]');
      if (status) status.textContent = text || '';
      this.removeAttribute('aria-busy');
    }

    readAddress() {
      return Object.fromEntries([...this.querySelectorAll('[data-shipping-field]')].map((field) => [field.dataset.shippingField, field.value]));
    }

    calculate = (event) => {
      event?.preventDefault();
      const values = this.readAddress();
      this.address = normalizedAddress(values);
      this.cancel();
      let firstInvalid = null;
      for (const field of this.querySelectorAll('[data-shipping-field]')) {
        const key = field.dataset.shippingField;
        const value = field.value.trim();
        const valid = key === 'zip' ? /^\d{5}(-\d{4})?$/.test(value) : key === 'province' ? states.has(value) : Boolean(value);
        field.setAttribute('aria-invalid', String(!valid));
        if (!valid && !firstInvalid) firstInvalid = field;
      }
      if (!this.address) {
        this.setStatus(this.dataset.invalidAddress);
        firstInvalid?.focus();
        return;
      }
      try {
        sessionStorage.setItem(addressKey, JSON.stringify({ address: this.address, expiresAt: Date.now() + addressLifetime }));
      } catch {}
      this.scheduleRefresh();
    };

    onAddressKeyDown = (event) => {
      if (event.key === 'Enter' && !event.isComposing && event.target.matches('[data-shipping-field]')) this.calculate(event);
    };

    onAddressEdit = (event) => {
      if (!event.target.matches('[data-shipping-field]')) return;
      this.address = null;
      this.cancel();
      event.target.removeAttribute('aria-invalid');
      this.setStatus(this.dataset.addressPrompt);
      try { sessionStorage.removeItem(addressKey); } catch {}
    };

    invalidateForChange = () => {
      this.cancel();
      this.setStatus(this.address ? this.dataset.loading : this.dataset.addressPrompt);
    };

    onVisibilityChange = () => {
      if (document.hidden) this.invalidateForChange();
      else this.scheduleRefresh();
    };

    scheduleRefresh = () => {
      this.cancel();
      this.setStatus(this.address ? this.dataset.loading : this.dataset.addressPrompt);
      if (this.address && this.isConnected && !document.hidden) this.scheduled = setTimeout(() => this.refresh(), 350);
    };

    async refresh() {
      this.cancel();
      if (!this.address || !this.isConnected || document.hidden) return;
      const generation = this.generation;
      const controller = new AbortController();
      this.active = controller;
      const { signal } = controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      const address = { ...this.address };
      this.setStatus(this.dataset.loading);
      this.setAttribute('aria-busy', 'true');
      const root = window.Shopify?.routes?.root || '/';
      const request = async (path, method = 'GET') => {
        const response = await fetch(`${root}${path}`, {
          method, credentials: 'same-origin', cache: 'no-store', signal,
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) {
          const error = new Error('Shipping estimate unavailable');
          error.addressUnavailable = response.status === 422 && /^cart\/(?:prepare_|async_)shipping_rates\.json\?/.test(path);
          throw error;
        }
        return response.json();
      };
      try {
        const before = await request('cart.js');
        if (!before.items?.length || !before.requires_shipping) throw new Error('No shippable cart');
        const identity = cartIdentity(before);
        const query = new URLSearchParams();
        for (const [key, value] of Object.entries(address)) query.set(`shipping_address[${key}]`, value);
        await request(`cart/prepare_shipping_rates.json?${query}`, 'POST');
        let payload = null;
        for (let attempt = 0; attempt < 10; attempt += 1) {
          payload = await request(`cart/async_shipping_rates.json?${query}`);
          if (payload !== null) break;
          await pause(750, signal);
        }
        const after = await request('cart.js');
        if (identity !== cartIdentity(after)) {
          if (generation === this.generation) this.scheduleRefresh();
          return;
        }
        if (Array.isArray(payload?.shipping_rates) && payload.shipping_rates.length === 0) {
          const error = new Error('No shipping rates for address');
          error.addressUnavailable = true;
          throw error;
        }
        const rates = normalizeRates(payload, after.currency, this.dataset.carrierServiceId);
        if (generation !== this.generation || signal.aborted || !this.isConnected) return;
        this.renderRates(rates, address);
        this.expiry = setTimeout(this.scheduleRefresh, rateLifetime);
      } catch (error) {
        if (generation === this.generation && this.isConnected) {
          this.setStatus(error?.addressUnavailable ? this.dataset.noRates : this.dataset.unavailable);
          const details = this.querySelector('[data-shipping-address]');
          if (details) details.open = true;
          const support = this.querySelector('[data-shipping-support]');
          if (support) support.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        if (generation === this.generation) this.removeAttribute('aria-busy');
      }
    }

    renderRates(rates, address) {
      const dateFormat = new Intl.DateTimeFormat(this.dataset.locale || 'en', {
        month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
      });
      for (const row of this.querySelectorAll('[data-service-code]')) {
        const rate = rates.find((candidate) => candidate.code === row.dataset.serviceCode);
        row.hidden = !rate;
        if (!rate) continue;
        row.querySelector('.yurinox-estimated-delivery__service-name').textContent = rate.name;
        const price = row.querySelector('[data-shipping-price]');
        price.classList.toggle('yurinox-estimated-delivery__price--free', rate.free);
        price.textContent = rate.free ? this.dataset.free.toUpperCase() : new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency', currency: rate.currency,
        }).format(rate.price);
        price.hidden = false;
        const dateContainer = row.querySelector('[data-shipping-date]');
        const dateValue = row.querySelector('[data-shipping-date-value]');
        dateValue.replaceChildren();
        const dates = [...new Set(rate.dates.map((date) => date.toISOString().slice(0, 10)))];
        dateContainer.hidden = !dates.length;
        dates.forEach((value, index) => {
          if (index) dateValue.append(document.createTextNode(' – '));
          const time = document.createElement('time');
          time.dateTime = value;
          time.textContent = dateFormat.format(calendarDate(value));
          dateValue.append(time);
        });
      }
      const status = this.querySelector('[data-shipping-status]');
      const noDate = rates.some((rate) => !rate.dates.length) ? ` ${this.dataset.noDate}` : '';
      status.textContent = `${this.dataset.estimatedFor} ${address.zip}, ${address.province}. ${this.dataset.finalNote}${noDate}`;
    }
  }

  customElements.define('yurinox-estimated-delivery', YurinoxEstimatedDelivery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yx-bib-second-unit"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('yx-bib-second-unit')) return;
    customElements.define('yx-bib-second-unit', class extends HTMLElement {
      connectedCallback() {
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';
    const offer = this.querySelector('[data-yx-bib-second]');
    if (!offer) return;
    const cartRoot = offer.closest('[data-yx-cart]');
    const select = offer.querySelector('[data-yx-bib-second-variant]');
    const add = offer.querySelector('[data-yx-bib-second-add]');
    const subtotal = offer.querySelector('[data-yx-bib-second-subtotal]');
    const total = offer.querySelector('[data-yx-bib-second-total]');
    const error = offer.querySelector('[data-yx-bib-second-error]');
    const refresh = offer.querySelector('[data-yx-bib-second-refresh]');
    const root = window.Shopify?.routes?.root || '/';
    const url = (path) => `${root}${path}`;
    const request = async (path, options = {}, timeout = 8000) => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), timeout);
      try {
        const response = await fetch(url(path), { ...options, signal: controller.signal });
        const data = await response.json();
        return { ok: response.ok, status: response.status, data };
      }
      finally { window.clearTimeout(timer); }
    };
    const marker = { version: '1', product_id: offer.dataset.productId, original_variant_id: offer.dataset.originalVariantId };
    let markerQueue = Promise.resolve();
    let lastMarkerPayload = '';
    let pending = false;
    let uncertain = false;
    const saveMarker = (fields) => {
      Object.assign(marker, fields);
      markerQueue = markerQueue.catch(() => {}).then(() => {
        const payload = JSON.stringify({ attributes: { __yx_bib_second_unit: JSON.stringify(marker) } });
        if (payload === lastMarkerPayload) return;
        lastMarkerPayload = payload;
        return request('cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: payload,
        }, 2000);
      }).catch(() => {});
      return markerQueue;
    };
    const markShown = () => {
      if (marker.shown_at) return;
      saveMarker({ shown_at: new Date().toISOString() });
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        markShown();
        observer.disconnect();
      }, { threshold: .5 });
      observer.observe(offer.querySelector('summary'));
    } else {
      offer.addEventListener('toggle', () => { if (offer.open) markShown(); }, { once: true });
    }
    const showSelection = () => {
      const option = select.selectedOptions[0];
      const valid = Boolean(select.value && option && !option.disabled);
      add.disabled = !valid || pending || uncertain;
      add.textContent = valid ? `${offer.dataset.addLabel} — ${option.dataset.price}` : offer.dataset.addLabel;
      subtotal.hidden = !valid;
      total.textContent = valid ? option.dataset.subtotal : '';
    };
    select.addEventListener('change', () => {
      error.hidden = true;
      showSelection();
      if (select.value) {
        markShown();
        saveMarker({ selected_variant_id: select.value });
      }
    });
    cartRoot.addEventListener('submit', (event) => { if (pending) event.preventDefault(); });
    add.addEventListener('click', async () => {
      if (pending || uncertain || !select.value || select.selectedOptions[0].disabled || cartRoot.getAttribute('aria-busy') === 'true') return;
      pending = true;
      error.hidden = true;
      refresh.hidden = true;
      const chosenVariant = select.value;
      const controls = [...cartRoot.querySelectorAll('button, input, select, textarea')];
      const disabledBefore = controls.map((control) => control.disabled);
      controls.forEach((control) => { control.disabled = true; });
      cartRoot.setAttribute('aria-busy', 'true');
      add.textContent = offer.dataset.pendingLabel;
      let addStarted = false;
      let confirmed = false;
      try {
        markShown();
        saveMarker({ selected_variant_id: chosenVariant });
        const currentResponse = await request('cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!currentResponse.ok) throw new Error('unknown');
        const current = currentResponse.data;
        if (current.item_count !== 1 || current.items.length !== 1 || current.items[0].key !== offer.dataset.originalLineKey || String(current.items[0].product_id) !== offer.dataset.productId) throw new Error('changed');
        addStarted = true;
        const response = await request('cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(chosenVariant), quantity: 1 }] }),
        });
        if (response.status === 422) { addStarted = false; throw new Error('stock'); }
        if (!response.ok) throw new Error('unknown');
        confirmed = true;
        await saveMarker({ add_accepted_at: new Date().toISOString() });
        window.location.reload();
      } catch (failure) {
        if (confirmed) { window.location.reload(); return; }
        uncertain = addStarted || failure.message === 'changed';
        error.textContent = failure.message === 'stock' ? offer.dataset.errorStock : failure.message === 'changed' ? offer.dataset.errorChanged : offer.dataset.errorUnknown;
        error.hidden = false;
        refresh.hidden = failure.message === 'stock';
        if (failure.message === 'stock') { select.selectedOptions[0].disabled = true; select.value = ''; }
        controls.forEach((control, index) => { control.disabled = disabledBefore[index]; });
        pending = false;
        cartRoot.removeAttribute('aria-busy');
        showSelection();
      }
    });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
